import api from "./axios";

export const http = {
    get: (url, { params } = {}) => api.get(url, { params }).then((response) => response.data),
    post: (url, body) => api.post(url, body).then((response) => response.data),
    put: (url, body) => api.put(url, body).then((response) => response.data),
    patch: (url, body) => api.patch(url, body).then((response) => response.data),
    delete: (url, payload = {}) => api.delete(url, { data: payload }).then((response) => response.data)
};
